export const completedAction = (state, payload) => {
  return {
    ...state,
    completed: payload
  };
};
